module.exports = __webpack_public_path__ + "assets/img/TrendingNow_project_future.2fae2de6-ps.jpg";